import { useTranslation } from "react-i18next";
import { NeedsListView } from "./NeedsListView";

export const MineBehov = () => {
  const { t } = useTranslation();
  return (
    <NeedsListView
      title={t("My needs")}
      description={t("Needs you have registered.")}
      mineOnly={true}
      urlStatusSync={false}
    />
  );
};
